import { z } from 'zod';

// The CIHR HRTP report (/api/reports/cihr). Schemas check shape only: the first reportable year,
// who may read Tab C and the template's contents stay in cihrReportService and the routes.
// CihrTab mirrors TAB_KEYS in config/cihrReport.ts (the tests compare them).

export const CihrTab = z.enum(['A', 'B', 'C', 'D', 'M']);
export type CihrTab = z.infer<typeof CihrTab>;

const YearText = z.string().regex(/^\d{4}$/, 'is not a year');
const Text = z.string().nullish();

/** The range (from the first reportable year) is checked by the service. */
export const CihrYearParams = z.strictObject({ year: YearText });

/** Any id; one that is not a snapshot's is answered 404 by the route. */
export const CihrSnapshotParams = z.strictObject({ id: z.string() });

export const CihrSnapshotsQuery = z.strictObject({ year: z.union([YearText, z.literal('')]).optional() });
export type CihrSnapshotsQuery = z.input<typeof CihrSnapshotsQuery>;

/** The tab letter in either case; B when absent. */
export const CihrCsvQuery = z.strictObject({
  tab: z
    .string()

    .refine((s) => s === '' || (CihrTab.options as readonly string[]).includes(s.toUpperCase()), 'Unknown tab')
    .optional(),
});
export type CihrCsvQuery = z.input<typeof CihrCsvQuery>;

/** Base64 .xlsx (a data: prefix is allowed); the workbook itself is checked by the service. */
export const CihrTemplateRequest = z.strictObject({ fileName: Text, content: z.string() });
export type CihrTemplateRequest = z.input<typeof CihrTemplateRequest>;

export const CihrSnapshotRequest = z.strictObject({
  note: Text,
  submittedFile: z.strictObject({ fileName: Text, content: Text }).nullish(),
  submittedSha256: Text,
});
export type CihrSnapshotRequest = z.input<typeof CihrSnapshotRequest>;
